import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Filter } from 'src/app/models/filter';
import { PaginatedResult, Util } from 'src/app/util';
import { Icon } from 'src/app/models/record';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ViewAllValuesDialogComponent } from '../view-all-values-dialog/view-all-values-dialog.component';
import { ActivatedRoute, Router } from '@angular/router';
import { OtkList, ViewAllValuesDialogData } from '../../models/user-item-list';
import { FilterValue } from '../../models/filter-value';
import { ConfigService } from 'src/app/services/config.service';
import { InfoDialogFacade } from 'src/app/_core/state/dialogs/info/info.facade';

@Component({
  selector: 'app-format-filter',
  templateUrl: './format-filter.component.html',
  styleUrls: ['./format-filter.component.scss'],
})
export class FormatFilterComponent implements OnInit, OnChanges {
  private readonly infoDialogFacade = inject(InfoDialogFacade);

  @Input()
  filter: Filter;

  @Input()
  lists: Filter;

  @Output()
  filterSelected = new EventEmitter<any>();

  paginatedPublicLists: PaginatedResult<OtkList>;
  publicLists: OtkList[];
  listIds: number[];
  filteredPublicList: Filter;
  publicListMap = new Map<string, number>();
  selectedFilter: string;
  traditionalFilterKeys: FilterValue[] = [];
  experiencesFilterKeys: FilterValue[] = [];
  physicalFilterKeys: FilterValue[] = [];
  filterFormatInfoMap = new Map<FilterValue, Icon>();

  constructor(
    private configService: ConfigService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((queryParams) => {
      const facets: string = queryParams.facets;

      if (facets && facets.includes(Util.FORMAT_FILTER)) {
        const formatFilter = facets.split(';').find((f) => f.startsWith(Util.FORMAT_FILTER));
        const parts = formatFilter.split(':');
        this.selectedFilter = parts[1].replace(/"/g, '');
      } else {
        delete this.selectedFilter;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.filter && this.filter) {
      this.filterFormatInfoMap.clear();
      Util.fillFormatFilterInfoMap(this.filterFormatInfoMap, this.filter);

      this.traditionalFilterKeys = [];
      this.experiencesFilterKeys = [];
      this.physicalFilterKeys = [];

      this.filter.values.forEach((filterValue) => {
        if (Util.isLearningExperienceFilterValue(filterValue)) {
          this.experiencesFilterKeys.push(filterValue);
        } else if (Util.isPhysicalFilterValue(filterValue)) {
          this.physicalFilterKeys.push(filterValue);
        } else {
          this.traditionalFilterKeys.push(filterValue);
        }
      });
    }
  }

  getFormatInfo(format: string, iconId?: string): Icon {
    return Util.resolveIcon(format, iconId);
  }

  applyFilter(name: string, value: string) {
    this.filterSelected.emit({ name: name, value: value });
  }

  openDialog() {
    const data: ViewAllValuesDialogData = {
      filter: this.filteredPublicList,
      paginatedLists: this.paginatedPublicLists,
      listIds: this.listIds,
    };
    this.dialog
      .open(ViewAllValuesDialogComponent, {
        data: data,
      })
      .afterClosed()
      .subscribe((selected) => {
        if (selected) {
          const slug = Util.slugify(selected.name) + '-' + selected.id;
          this.router.navigate(['/list', slug]);
        }
      });
  }

  openExperiencesInfoDialog() {
    this.infoDialogFacade.openDialog(
      this.configService.getAvailableExperiencesInfoDialogData().title,
      this.configService.getAvailableExperiencesInfoDialogData().intro,
      this.configService.getAvailableExperiencesInfoDialogData().items
    );
  }

  /**
   * Don't show filtered public list
   */
  showFilteredPublicLists() {
    return !(
      this.traditionalFilterKeys !== undefined &&
      this.traditionalFilterKeys.some((filterKey) => filterKey.name === 'LIST')
    );
  }
}
